import { Switch, Route, Redirect } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Quizzes from "@/pages/quizzes";
import TakeQuiz from "@/pages/take-quiz";
import EditQuiz from "@/pages/edit-quiz";
import QuizResults from "@/pages/quiz-results";
import QuizDetail from "@/pages/quiz-detail";
import QuizInternal from "@/pages/quiz-internal";
import Auth from "@/pages/auth";
import CreateQuiz from "@/pages/create-quiz";
import Pricing from "@/pages/pricing";
import TermsOfService from "@/pages/terms";
import PrivacyPolicy from "@/pages/privacy";
import { AuthProvider } from "@/hooks/use-auth";
import { useMixpanel } from "@/hooks/use-mixpanel";

function Router() {
  // Initialize Mixpanel tracking
  useMixpanel();

  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/auth" component={Auth} />
      <Route path="/quizzes" component={Quizzes} />
      <Route path="/create-quiz" component={CreateQuiz} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/terms" component={TermsOfService} />
      <Route path="/privacy" component={PrivacyPolicy} />

      {/* Public routes using share code */}
      <Route path="/quiz/t/:shareCode" component={TakeQuiz} />

      {/* Management routes using internal ID */}
      <Route path="/quiz/:internalId" component={QuizInternal} />

      <Route path="/quiz/:internalId/results" component={QuizResults} />

      {/* Redirect old routes */}
      <Route path="/create">
        {() => <Redirect to="/quizzes" />}
      </Route>
      <Route path="/my-quizzes">
        {() => <Redirect to="/quizzes" />}
      </Route>

      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;